import { useEffect } from "react";
import { COMPANY } from "@/i18n/translations";

// Site-wide LocalBusiness schema injected once via Layout.
export const SchemaLocalBusiness = () => {
  useEffect(() => {
    const id = "site-localbusiness-jsonld";
    const data = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: COMPANY.brandFull,
      alternateName: COMPANY.brand,
      description:
        "Integrated Facility Management, Cleaning, Maintenance and Manpower across Dubai, Abu Dhabi, Sharjah and Ajman, UAE.",
      url: `https://${COMPANY.domain}`,
      logo: COMPANY.logo,
      image: COMPANY.logo,
      telephone: COMPANY.phone,
      email: COMPANY.email,
      priceRange: "AED",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Ajman Freezone",
        addressLocality: "Ajman",
        addressCountry: "AE",
      },
      areaServed: [
        { "@type": "City", name: "Dubai" },
        { "@type": "City", name: "Abu Dhabi" },
        { "@type": "City", name: "Sharjah" },
        { "@type": "City", name: "Ajman" },
      ],
      sameAs: [COMPANY.social.instagram, COMPANY.social.facebook],
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
        opens: "08:00",
        closes: "18:00",
      },
    };
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  }, []);
  return null;
};
